import { useState } from 'react';

const useFilters = ({ filterValues }) => {
  const [localFilterValues, setLocalFilterValues] = useState({
    ...filterValues,
  });

  const updateFilter = ({ values, hasApplyFilter, applyFilter }) => {
    if (hasApplyFilter) {
      applyFilter(values);
    }
    setLocalFilterValues(values);
  };

  return {
    localFilterValues: localFilterValues,
    updateFilter,
  };
};

export default useFilters;
